<app-login-layout-sofa>
  <div class="main-section">
    <app-login-email></app-login-email>
  </div>
</app-login-layout-sofa>
